import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PageTemplate } from "./montagem-template";
import { Image, Text, ChevronDown, Edit2 } from "lucide-react";
import "./template-pagina.scss";
import * as api from "../../api/outrasPaginas";

let modelosCache: any[] | null = null;
let modelosPromise: Promise<any[]> | null = null;

const fetchModelosCached = async () => {
  if (modelosCache) {
    return modelosCache;
  }
  if (!modelosPromise) {
    modelosPromise = api
      .listarModelos()
      .then((data: any[]) => {
        modelosCache = data;
        return data;
      })
      .catch((error) => {
        console.error("Erro ao buscar modelos:", error);
        return [];
      });
  }
  return modelosPromise;
};

const redirecionarUrl = (codModelo: number): string => {
  const hash = window.location.hash;
  const urlAtual = hash.startsWith("#") ? hash.substring(1) : hash;
  if (urlAtual.includes("/editar-pagina/")) {
    const partes = urlAtual.split("/");
    const idx = partes.findIndex((parte) => parte === "editar-pagina");
    const idDaPagina = partes[idx + 1] || "";
    return `/cms/edicao-cidade-inteligente/outras-paginas/editar-pagina-modelo-${codModelo}/${idDaPagina}`;
  }
  return `/cms/edicao-cidade-inteligente/outras-paginas/inserir-pagina/modelo-${codModelo}`;
};

const ApresentacaoSecretariaTemplate = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [codModelo, setCodModelo] = useState<number>(0);

  useEffect(() => {
    const fetchModelo = async () => {
      const data = await fetchModelosCached();
      if (data.length > 0) {
        setTitle(data[0].dscModeloPagina);
        setCodModelo(data[0].codModeloPagina);
      }
    };
    fetchModelo();
  }, []);

  return (
    <PageTemplate title={title} onClick={() => navigate(redirecionarUrl(codModelo))}>
      <div className="template template--select-menu">
        <div className="template__header template__header--blue">
          <Text className="template__icon template__icon--white" />
        </div>
        {[1, 2, 3].map((i) => (
          <div key={i} className="template__select-group">
            <div className="template__select-item">
              <ChevronDown className="template__icon template__icon--gray" />
            </div>
            <div className="template__sub-item-group">
              <div className="template__line template__line--short" />
              <div className="template__line template__line--long" />
            </div>
          </div>
        ))}
      </div>
    </PageTemplate>
  );
};

const ApresentacaoOrganogramaTemplate = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [codModelo, setCodModelo] = useState<number>(0);

  useEffect(() => {
    const fetchModelo = async () => {
      const data = await fetchModelosCached();
      if (data.length >= 1) {
        setTitle(data[1].dscModeloPagina);
        setCodModelo(data[1].codModeloPagina);
      }
    };
    fetchModelo();
  }, []);

  return (
    <PageTemplate title={title} onClick={() => navigate(``)}>
      <div className="template template--header-content">
        <div className="template__header">
          <Text className="template__icon" />
        </div>
        <div className="template__content">
          <Image className="template__icon" />
        </div>
      </div>
    </PageTemplate>
  );
};

export const TextolivreTemplate = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [codModelo, setCodModelo] = useState<number>(0);

  useEffect(() => {
    const carregarModelo = async () => {
      const data = await fetchModelosCached();
      if (data.length >= 2) {
        setTitle(data[2].dscModeloPagina);
        setCodModelo(data[2].codModeloPagina);
      }
    };
    carregarModelo();
  }, []);

  return (
    <PageTemplate title={title} onClick={() => navigate(redirecionarUrl(codModelo))}>
      <div className="template template--text-field">
        <div className="template__header">
          <Text className="template__icon" />
        </div>
        <div className="template__content">
          <Text className="template__icon" />
        </div>
      </div>
    </PageTemplate>
  );
};

export const MidiaLivreTemplate = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [codModelo, setCodModelo] = useState<number>(0);

  useEffect(() => {
    const fetchModelo = async () => {
      const data = await fetchModelosCached();
      if (data.length >= 3) {
        setTitle(data[3].dscModeloPagina);
        setCodModelo(data[3].codModeloPagina);
      }
    };
    fetchModelo();
  }, []);

  return (
    <PageTemplate title={title} onClick={() => navigate(redirecionarUrl(codModelo))}>
      <div className="template template--header-content">
        <div className="template__header">
          <Text className="template__icon" />
        </div>
        <div className="template__content">
          <Image className="template__icon" />
        </div>
      </div>
    </PageTemplate>
  );
};

export const LinhaDoTempoTemplate = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [codModelo, setCodModelo] = useState<number>(0);

  useEffect(() => {
    const fetchModelo = async () => {
      const data = await fetchModelosCached();
      if (data.length >= 2) {
        setTitle(data[4].dscModeloPagina);
        setCodModelo(data[4].codModeloPagina);
      }
    };
    fetchModelo();
  }, []);

  return (
    <PageTemplate title={title} onClick={() => navigate(redirecionarUrl(codModelo))}>
      <div className="template template--text-field">
        <div className="template__header">
          <Text className="template__icon" />
        </div>
        <div className="template__content">
          <Text className="template__icon" />
        </div>
      </div>
    </PageTemplate>
  );
};

export const templates = [
  { id: 1, component: ApresentacaoSecretariaTemplate },
  { id: 2, component: ApresentacaoOrganogramaTemplate },
  { id: 3, component: TextolivreTemplate },
  { id: 4, component: MidiaLivreTemplate },
  { id: 5, component: LinhaDoTempoTemplate },
];
